import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../theme';
import { applyBoxShadowAfter } from '../../styles/mixins';

export const useSearchFormElementsStyles = createStyles(({ token }) => ({
  inputSearch: {
    '&&': {
      ...applyBoxShadowAfter(token),
      ' input': {
        '&, &:focus': {
          boxShadow: 'none',
        },
        '&::placeholder': {
          color: ThemeColors.COLOR_GREY_BLUISH,
        },
      },
      '.ant-btn': {
        width: 30,
        padding: 0,
      },
    },
  },
  inputSearchFlat: {
    '.ant-form-item-control-input-content &.ant-input-affix-wrapper': {
      display: 'flex',
      alignItems: 'center',
      height: 27,
      border: `1px solid ${ThemeColors.COLOR_GREY8_7}`,
      backgroundColor: ThemeColors.COLOR_WHITE2,
      borderRadius: 15,
      padding: `0 ${ThemeSpaces.SPACE_SM}px 0 ${ThemeSpaces.SPACE_NORM_15}px`,
      boxShadow: 'none',

      '&::after': {
        content: 'none',
      },

      '.ant-input-prefix': {
        marginRight: ThemeSpaces.SPACE_SM,
        marginLeft: 0,
      },

      '.ant-input-suffix': {
        marginLeft: ThemeSpaces.SPACE_MD,
        '.fas, .far, .fal': {
          fontSize: 13,
        },
      },

      '.ant-input': {
        backgroundColor: 'transparent',
        color: ThemeColors.COLOR_GREY3,
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,

        '&::placeholder': {
          color: ThemeColors.COLOR_GREY_BLUISH,
          fontWeight: 400,
        },
      },
    },
  },
}));
